<template>

    <!-- Carousel Start -->
    <div class="container-fluid p-0 mb-5">
        <div id="header-carousel" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img class="w-100" src="/img/car1.jpg" alt="Image">
                    <div class="carousel-caption d-flex flex-column align-items-center justify-content-center">
                        <div class="p-3" style="max-width: 700px;">
                            <h6 class="section-title text-white text-uppercase mb-3 animated slideInDown">Ankara
                                Ağrılılar Derneği</h6>
                            <h1 class="display-3 text-white mb-4 animated slideInDown">Ankara'daki Ağrılılar aynı
                                çatı altında buluşuyor!</h1>
                            <p class="hero-phone text-white mb-4 animated slideInDown">
                                <i class="fa fa-phone-alt me-2"></i>Dernek hattı:
                                <a href="tel:+905079217404"><strong>+90 507 921 74 04</strong></a>
                            </p>
                            <a :href="whatsappJoinUrl" target="_blank" rel="noopener"
                                class="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">WhatsApp'tan Katıl</a>
                            <a href="tel:+905079217404" class="btn btn-light py-md-3 px-md-5 animated slideInRight">Bilgi
                                Al</a>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <img class="w-100" src="/img/car1.jpg" alt="Image">
                    <div class="carousel-caption d-flex flex-column align-items-center justify-content-center">
                        <div class="p-3" style="max-width: 700px;">
                            <h6 class="section-title text-white text-uppercase mb-3 animated slideInDown">Kültürünü
                                Koru, Geleceğe Taşı!</h6>
                            <h1 class="display-3 text-white mb-4 animated slideInDown">Değerlerini yaşat, nesillere
                                aktar!</h1>
                            <a :href="whatsappJoinUrl" target="_blank" rel="noopener"
                                class="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">WhatsApp'tan Katıl</a>
                            <a href="tel:+905079217404" class="btn btn-light py-md-3 px-md-5 animated slideInRight">Bilgi
                                Al</a>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <img class="w-100" src="/img/car3.jpeg" alt="Image">
                    <div class="carousel-caption d-flex flex-column align-items-center justify-content-center">
                        <div class="p-3" style="max-width: 700px;">
                            <h6 class="section-title text-white text-uppercase mb-3 animated slideInDown">Birlikte
                                Daha Fazla Kazan!</h6>
                            <h1 class="display-3 text-white mb-4 animated slideInDown">Dayanışmayla kazancını ve
                                başarını artır!</h1>
                            <a :href="whatsappJoinUrl" target="_blank" rel="noopener"
                                class="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">WhatsApp'tan Katıl</a>
                            <a href="tel:+905079217404" class="btn btn-light py-md-3 px-md-5 animated slideInRight">Bilgi
                                Al</a>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <img class="w-100" src="/img/car4.jpg" alt="Image">
                    <div class="carousel-caption d-flex flex-column align-items-center justify-content-center">
                        <div class="p-3" style="max-width: 700px;">
                            <h6 class="section-title text-white text-uppercase mb-3 animated slideInDown">Yalnız
                                Değilsin, Güçlüsün!</h6>
                            <h1 class="display-3 text-white mb-4 animated slideInDown">Destek al, işini ve kültürünü
                                yaşat!</h1>
                            <a :href="whatsappJoinUrl" target="_blank" rel="noopener"
                                class="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">WhatsApp'tan Katıl</a>
                            <a href="tel:+905079217404" class="btn btn-light py-md-3 px-md-5 animated slideInRight">Bilgi
                                Al</a>
                        </div>
                    </div>
                </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Önceki</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Sonraki</span>
            </button>
        </div>
    </div>
    <!-- Carousel End -->

    <!-- Hızlı Erişim Start -->
    <section class="quick-actions-section">
        <div class="container">
            <div class="quick-actions-grid">
                <a href="tel:+905079217404" class="quick-action-card">
                    <i class="fa fa-phone-alt"></i>
                    <span>Derneği Ara</span>
                    <strong>+90 507 921 74 04</strong>
                </a>
                <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="quick-action-card primary">
                    <i class="fab fa-whatsapp"></i>
                    <span>WhatsApp Grubuna Katıl</span>
                    <strong>Hazır mesajla başvur</strong>
                </a>
                <router-link to="/etkinlikler" class="quick-action-card">
                    <i class="fa fa-calendar-alt"></i>
                    <span>Etkinlikleri Gör</span>
                    <strong>Piknik, destek, kültür, eğitim</strong>
                </router-link>
                <router-link to="/firmalar" class="quick-action-card">
                    <i class="fa fa-building"></i>
                    <span>Ağrılı Firmalar</span>
                    <strong>Esnaf ve iş ağı</strong>
                </router-link>
            </div>
        </div>
    </section>
    <!-- Hızlı Erişim End -->

    <!-- Katilim Start -->
    <section class="container-xxl py-5">
        <div class="container">
            <div class="row g-5 align-items-center">
                <div class="col-lg-7 wow fadeInUp" data-wow-delay="0.1s">
                    <h6 class="section-title text-start text-primary text-uppercase">Hemşehri Buluşması</h6>
                    <h2 class="mb-4">Ankara'da yaşayan Ağrılıları, Doğubayazıtlıları ve Patnosluları bir araya
                        getiriyoruz</h2>
                    <p class="text-body mb-4">
                        Ankara Ağrılılar Derneği; Ağrı merkez, Doğubayazıt, Patnos, Diyadin, Eleşkirt, Tutak,
                        Taşlıçay ve Hamur'dan gelen hemşehrilerimizin tanışması, dayanışması ve ortak projelerde
                        buluşması için kurulmuş güçlü bir topluluktur.
                    </p>
                    <p class="text-body mb-4">
                        Dernek grubumuza katılarak etkinlik duyurularını takip edebilir, Ankara'daki Ağrılı esnaflar
                        ve ailelerle iletişim kurabilir, eğitim, iş, danışmanlık ve sosyal destek çalışmalarımızdan
                        haberdar olabilirsiniz.
                    </p>
                    <p class="text-body mb-4">
                        Amacımız ilçe derneklerinin yerine geçmek değil; Ankara'daki Doğubayazıtlılar, Patnoslular,
                        Diyadinliler, Eleşkirtililer, Tutaklılar, Taşlıçaylılar, Hamurlular ve tüm Ağrılılar arasında
                        ortak bir iletişim ve dayanışma köprüsü kurmaktır.
                    </p>
                    <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="btn btn-primary py-3 px-5 me-2">
                        WhatsApp Grubuna Katıl
                    </a>
                    <a href="tel:+905079217404" class="btn btn-outline-primary py-3 px-5">Derneği Ara</a>
                </div>
                <div class="col-lg-5 wow fadeInUp" data-wow-delay="0.2s">
                    <div class="join-panel">
                        <h3 class="mb-3">Aramıza Katılın</h3>
                        <p class="mb-4">
                            Butona tıkladığınızda WhatsApp'ta hazır mesaj açılır:
                        </p>
                        <p class="join-message mb-4">"Derneğinize websitesinden katıldım, herkese merhabalar."</p>
                        <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="btn btn-dark w-100 py-3">
                            Hazır Mesajla Başvur
                        </a>
                    </div>
                </div>
            </div>
            <div class="district-list mt-5" aria-label="Ağrı ilçe hemşehri toplulukları">
                <router-link v-for="district in DISTRICTS" :key="district.slug" :to="`/ilceler/${district.slug}`">
                    {{ district.communityName }}
                </router-link>
            </div>
        </div>
    </section>
    <!-- Katilim End -->




    <!-- Vizyon / Misyon Start -->
    <section class="container-xxl py-5 identity-section">
        <div class="container">
            <div class="identity-head text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 class="section-title text-center text-primary text-uppercase">Vizyon ve Misyon</h6>
                <h1>Ankara'daki Ağrılılar için güçlü, görünür ve güvenilir bir dayanışma ağı</h1>
                <p>
                    Derneğimiz; hemşehrilerimizi yalnızca aynı listede değil, aynı hedefte buluşturmayı amaçlar:
                    tanışma, yardımlaşma, kültür, eğitim, istihdam ve ortak fayda.
                </p>
            </div>

            <div class="identity-grid">
                <article class="identity-card vision-card wow fadeInUp" data-wow-delay="0.1s">
                    <div class="identity-card-icon">
                        <i class="fa fa-mountain-sun"></i>
                    </div>
                    <span>Vizyonumuz</span>
                    <h2>Birlikte daha güçlü bir Ankara Ağrılılar topluluğu kurmak</h2>
                    <p>
                        Ankara'da yaşayan tüm Ağrılıları bir araya getirerek güçlü bir dayanışma ve iş birliği
                        ekosistemi oluşturmak; kültürel, eğitsel, sosyal ve ekonomik kazanımları büyütmek.
                    </p>
                    <div class="identity-tags">
                        <strong>Kültür</strong>
                        <strong>Dayanışma</strong>
                        <strong>Güven</strong>
                    </div>
                </article>

                <article class="identity-card mission-card wow fadeInUp" data-wow-delay="0.2s">
                    <div class="identity-card-icon">
                        <i class="fa fa-hands-holding-circle"></i>
                    </div>
                    <span>Misyonumuz</span>
                    <h2>Hemşehrilerimizi doğru destek ve doğru insanlarla buluşturmak</h2>
                    <p>
                        Eğitim, iş, danışmanlık, sosyal destek, etkinlik ve firma tanıtımı alanlarında hemşehrilerimize
                        ulaşılabilir kanallar açmak; ilçe bağlarımızı koruyarak ortak hareket etmeyi kolaylaştırmak.
                    </p>
                    <div class="identity-tags">
                        <strong>Eğitim</strong>
                        <strong>İstihdam</strong>
                        <strong>Sosyal destek</strong>
                    </div>
                </article>
            </div>

            <div class="mission-pillars">
                <article v-for="pillar in missionPillars" :key="pillar.title" class="mission-pillar wow fadeInUp">
                    <i :class="`fa ${pillar.icon}`"></i>
                    <div>
                        <h3>{{ pillar.title }}</h3>
                        <p>{{ pillar.text }}</p>
                    </div>
                </article>
            </div>

            <div class="identity-action">
                <div>
                    <strong>Bugün tanışalım, yarın birlikte üretelim.</strong>
                    <span>Ankara'daki Ağrılılar için en hızlı iletişim kanalı WhatsApp grubumuzdur.</span>
                </div>
                <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="btn btn-primary">
                    <i class="fab fa-whatsapp me-2"></i>Gruba Katıl
                </a>
            </div>
        </div>
    </section>

    <!-- Vizyon / Misyon End -->

    <!-- Room Start -->
    <div class="container-xxl py-5 activities-page">
        <div class="container">
            <div class="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 class="section-title text-center text-primary text-uppercase">Faaliyetlerimiz</h6>
                <h1 class="mb-5">Dernekte öne çıkan <span class="text-primary text-uppercase">buluşmalar</span>
                </h1>
            </div>
            <div class="row g-4">
                <div v-for="activity in featuredActivities" :key="activity.title" class="col-lg-4 col-md-6 wow fadeInUp">
                    <article class="activity-card">
                        <div class="activity-media">
                            <img :src="activity.image" :alt="activity.title" />
                        </div>
                        <div class="activity-body">
                            <h5>{{ activity.title }}</h5>
                            <div class="activity-info">
                                <span v-for="info in activity.infos" :key="info.text">
                                    <i :class="`fa ${info.icon} text-primary`"></i>{{ info.text }}
                                </span>
                            </div>
                            <p>{{ activity.description }}</p>
                            <div class="activity-actions">
                                <router-link class="btn btn-sm btn-outline-primary" to="/etkinlikler">Detayları Gör</router-link>
                                <a class="btn btn-sm btn-dark" :href="whatsappJoinUrl" target="_blank" rel="noopener">
                                    {{ activity.cta }}
                                </a>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
            <div class="text-center mt-5">
                <router-link to="/etkinlikler" class="btn btn-primary py-3 px-5">
                    Tüm Etkinlikleri Gör
                </router-link>
            </div>
        </div>
    </div>
    <!-- Room End -->

    <!-- Impact Start -->
    <section class="container-xxl py-5">
        <div class="container">
            <div class="impact-band">
                <div>
                    <strong>200+</strong>
                    <span>Hemşehri ağı</span>
                </div>
                <div>
                    <strong>8</strong>
                    <span>Ağrı ilçesi</span>
                </div>
                <div>
                    <strong>16</strong>
                    <span>Etkinlik başlığı</span>
                </div>
                <div>
                    <strong>1</strong>
                    <span>Ortak dayanışma çatısı</span>
                </div>
            </div>
        </div>
    </section>
    <!-- Impact End -->

    <!-- Service Start -->
    <div class="container-xxl py-5">
        <div class="container">
            <div class="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 class="section-title text-center text-primary text-uppercase">Üyelik Avantajları</h6>
                <h1 class="mb-5">Hemşehrilerimize <span class="text-primary text-uppercase">Özel</span></h1>
            </div>
            <div class="row g-4">
                <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                    <a class="service-item rounded" href="">
                        <div class="service-icon bg-transparent border rounded p-1">
                            <div class="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                                <i class="fa fa-address-book fa-2x text-primary"></i>
                            </div>
                        </div>
                        <h5 class="mb-3">Danışmanlık</h5>
                        <p class="text-body mb-0">Sağlık, sigorta, yazılım ve hukuk alanındaki uzman
                            hemşehrilerimizle sizi buluşturarak ücretsiz danışmanlık sağlıyoruz.
                        </p>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.2s">
                    <router-link class="service-item rounded" to="/firmalar">
                        <div class="service-icon bg-transparent border rounded p-1">
                            <div class="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                                <i class="fa fa-building fa-2x text-primary"></i>
                            </div>
                        </div>
                        <h5 class="mb-3"> İş Bulma</h5>
                        <p class="text-body mb-0">İş arayan hemşehrilerimizi eleman arayan firmalarla bir araya
                            getiriyor, istihdam süreçlerine destek oluyoruz.
                        </p>
                    </router-link>
                </div>
                <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                    <router-link class="service-item rounded" to="/firmalar">
                        <div class="service-icon bg-transparent border rounded p-1">
                            <div class="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                                <i class="fa fa-wallet fa-2x text-primary"></i>
                            </div>
                        </div>
                        <h5 class="mb-3">Müşteri Kazanma</h5>
                        <p class="text-body mb-0">Hemşehrilerimize ait işletmeleri tanıtarak, diğer üyelerimizi
                            ihtiyaçları doğrultusunda yönlendiriyoruz</p>
                    </router-link>
                </div>
                <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.4s">
                    <a class="service-item rounded" href="">
                        <div class="service-icon bg-transparent border rounded p-1">
                            <div class="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                                <i class="fa fa-school fa-2x text-primary"></i>
                            </div>
                        </div>
                        <h5 class="mb-3">Eğitim</h5>
                        <p class="text-body mb-0">Gençler için kariyer danışmanlığı, çocuklar için yazılım ve
                            robotik programlama, yabancı dil... eğitimleri sunuyoruz.</p>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                    <a class="service-item rounded" href="">
                        <div class="service-icon bg-transparent border rounded p-1">
                            <div class="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                                <i class="fa fa-flag fa-2x text-primary"></i>
                            </div>
                        </div>
                        <h5 class="mb-3">Ağrı'mız İçin</h5>
                        <p class="text-body mb-0">Şehrimizin eğitim, ekonomi ve turizm alanındaki ihtiyaçlarını
                            belirleyerek, tanıtım ve kalkınma faaliyetlerini destekliyoruz</p>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
                    <router-link class="service-item rounded" to="/firmalar">
                        <div class="service-icon bg-transparent border rounded p-1">
                            <div class="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                                <i class="fa fa-users fa-2x text-primary"></i>
                            </div>
                        </div>
                        <h5 class="mb-3">Eleman Bulma</h5>
                        <p class="text-body mb-0">Firma sahibi hemşehrilerimize güvenilir elemanlar yönlendirerek iş
                            gücü ihtiyaçlarını karşılamalarına yardımcı oluyoruz.</p>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
    <!-- Service End -->

    <!-- İlkeler Start -->
    <section class="container-xxl py-5 principles-section">
        <div class="container">
            <div class="principles-head text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 class="section-title text-center text-primary text-uppercase">Dernek Kuralları</h6>
                <h1>Üyeler için <span class="text-primary text-uppercase">temel ilkeler</span></h1>
                <p>
                    Derneğimizde herkesin kendini güvende, değerli ve söz sahibi hissetmesi için ortak davranış
                    çerçevemizi sade ve anlaşılır tutuyoruz.
                </p>
            </div>

            <div class="principles-grid">
                <article v-for="principle in principles" :key="principle.title" class="principle-card wow fadeInUp">
                    <div class="principle-icon">
                        <i :class="`fa ${principle.icon}`"></i>
                    </div>
                    <h3>{{ principle.title }}</h3>
                    <p>{{ principle.text }}</p>
                </article>
            </div>

            <div class="principles-signature">
                <div>
                    <span>Dernek Başkanı</span>
                    <strong>Kasım Vural</strong>
                </div>
                <div>
                    <span>Kadın Kolları Dernek Başkanı</span>
                    <strong>Nürten Bulut</strong>
                </div>
                <router-link to="/kurullar" class="btn btn-dark">
                    Kurulları Gör
                </router-link>
            </div>
        </div>
    </section>

    <!-- İlkeler End -->

    <!-- Faydalı Bilgiler Start -->
    <section id="sss" class="useful-section">
        <div class="container-xxl py-5">
            <div class="container">
                <div class="useful-head text-center">
                    <h6 class="section-title text-center text-primary text-uppercase">Faydalı Bilgiler</h6>
                    <h1>İhtiyaç anında hızlı ulaşılacak <span class="text-primary text-uppercase">rehber</span></h1>
                    <p>
                        Ankara'da yaşayan Ağrılı hemşehrilerimiz için taziye, ulaşım, ilçe temsilcilikleri,
                        esnaf rehberi ve Ağrı bağlantılı pratik bilgileri tek yerde topluyoruz.
                    </p>
                </div>

                <div class="useful-feature">
                    <div>
                        <span>Acil bilgi</span>
                        <h2>Cenaze aracı ve taziye yeri için hızlı iletişim</h2>
                        <p>
                            Öncelikle Ankara Büyükşehir Belediyesi'nin cenaze hizmetleri için
                            <a href="tel:153">153</a> aranabilir. Dernek ofisi taziye ve hemşehri desteği için
                            uygunluk durumuna göre yönlendirme yapar.
                        </p>
                    </div>
                    <div class="useful-feature-actions">
                        <a href="tel:153" class="btn btn-primary">
                            <i class="fa fa-phone-alt me-2"></i>153 Ara
                        </a>
                        <a href="tel:05054841050" class="btn btn-dark">
                            <i class="fa fa-phone-alt me-2"></i>Taziye İrtibatı
                        </a>
                    </div>
                </div>

                <div class="useful-grid">
                    <article v-for="item in usefulInfoItems" :key="item.title" class="useful-card">
                        <div class="useful-card-icon">
                            <i :class="item.icon"></i>
                        </div>
                        <div class="useful-card-body">
                            <span>{{ item.category }}</span>
                            <h3>{{ item.title }}</h3>
                            <p>{{ item.text }}</p>
                            <div class="useful-card-actions">
                                <a
                                    v-if="item.href"
                                    :href="item.href"
                                    :target="item.external ? '_blank' : undefined"
                                    :rel="item.external ? 'noopener' : undefined"
                                    class="btn btn-sm"
                                    :class="item.primary ? 'btn-primary' : 'btn-outline-primary'"
                                >
                                    {{ item.action }}
                                </a>
                                <router-link
                                    v-if="item.route"
                                    :to="item.route"
                                    class="btn btn-sm btn-outline-primary"
                                >
                                    {{ item.action }}
                                </router-link>
                            </div>
                        </div>
                    </article>
                </div>

                <div class="useful-note">
                    <i class="fa fa-circle-info"></i>
                    <p>
                        Bilgiler zamanla güncellenebilir. Yanlış veya eksik gördüğünüz bir bilgi varsa dernek hattına
                        ulaşarak düzeltilmesine yardımcı olabilirsiniz.
                    </p>
                </div>
            </div>
        </div>
    </section>
    <!-- Faydalı Bilgiler End -->


</template>

<script setup>
import DISTRICTS from '@/data/districts'
import ACTIVITIES from '@/data/activities'

const whatsappMessage = 'Derneğinize websitesinden katıldım, herkese merhabalar.'
const whatsappJoinUrl = `https://wa.me/905079217404?text=${encodeURIComponent(whatsappMessage)}`
const featuredActivities = ACTIVITIES.slice(0, 3)

const missionPillars = [
    {
        icon: 'fa-people-group',
        title: 'Hemşehri Bağı',
        text: 'Ağrı merkez ve tüm ilçe topluluklarını Ankara’da tanışma, iletişim ve dayanışma zeminiyle buluşturuyoruz.'
    },
    {
        icon: 'fa-briefcase',
        title: 'İş ve Destek Ağı',
        text: 'Esnaf, öğrenci, çalışan ve iş arayan hemşehriler arasında güvenilir yönlendirme ve destek kanalları kuruyoruz.'
    },
    {
        icon: 'fa-landmark',
        title: 'Kültürel Hafıza',
        text: 'Ağrı’nın kültürünü, aile bağını ve dayanışma geleneğini Ankara’da yaşayan yeni nesillere aktarıyoruz.'
    }
]

const principles = [
    {
        icon: 'fa-handshake',
        title: 'Saygı ve Nezaket',
        text: 'Fikir ayrılıklarında bile seviyeli, yapıcı ve kardeşlik hukukunu koruyan bir dil esas alınır.'
    },
    {
        icon: 'fa-clipboard-check',
        title: 'Sorumluluk Bilinci',
        text: 'Her üye üstlendiği görevi takip eder; ortak hedefler düzenli emek ve sahiplenmeyle büyür.'
    },
    {
        icon: 'fa-hands-helping',
        title: 'Dayanışma ve İş Birliği',
        text: 'Derneğin gücü bireysel başarıdan değil, birbirine destek olan güçlü bir topluluktan doğar.'
    },
    {
        icon: 'fa-scale-balanced',
        title: 'Şeffaflık ve Adalet',
        text: 'Kararlar açık, adil ve üyelerin bilgisi dahilinde yürütülür; güven ortamı böyle korunur.'
    },
    {
        icon: 'fa-heart',
        title: 'Topluma Katkı',
        text: 'Çalışmalar yalnızca dernek içi faydaya değil; ailelere, gençlere ve Ankara’daki sosyal hayata katkıya yönelir.'
    },
    {
        icon: 'fa-calendar-check',
        title: 'Etkin Katılım',
        text: 'Toplantı, etkinlik ve çalışma gruplarına düzenli katılım derneğin canlı ve etkili kalmasını sağlar.'
    }
]

const usefulInfoItems = [
    {
        icon: 'fa fa-van-shuttle',
        category: 'Acil destek',
        title: 'Cenaze aracı',
        text: 'Ankara Büyükşehir Belediyesi cenaze aracı hizmeti için 153 aranabilir. Gerekirse dernek üzerinden güvenilir firma yönlendirmesi de alınabilir.',
        action: '153 Ara',
        href: 'tel:153',
        primary: true
    },
    {
        icon: 'fa fa-hands-praying',
        category: 'Taziye',
        title: 'Taziye yeri',
        text: 'Dernek ofisimiz uygunluk durumuna göre taziye kabulü ve hemşehri dayanışması için kullanılabilir.',
        action: 'İrtibatı Ara',
        href: 'tel:05054841050'
    },
    {
        icon: 'fa fa-plane-departure',
        category: 'Ulaşım',
        title: 'Ankara - Ağrı uçak bileti',
        text: 'Ankara ile Ağrı arasında direkt uçuş seçenekleri dönemsel olarak takip edilebilir.',
        action: 'Bilet Ara',
        href: 'https://www.enuygun.com/ucak-bileti/ankara-agri/',
        external: true
    },
    {
        icon: 'fa fa-bus',
        category: 'Ulaşım',
        title: 'Ağrı otobüs bileti',
        text: 'Metro, Aras, Vangölü ve benzeri firmaların Ağrı seferleri için online bilet seçenekleri incelenebilir.',
        action: 'Otobüs Bileti',
        href: 'https://www.obilet.com/otobus-bileti/agri',
        external: true
    },
    {
        icon: 'fa fa-mosque',
        category: 'Ağrı rehberi',
        title: 'Mezarlık ve camiler',
        text: 'Ağrı’daki mezarlık, cami ve belediye duyuruları için resmi belediye kaynakları takip edilebilir.',
        action: 'Ağrı Belediyesi',
        href: 'https://www.agri.bel.tr',
        external: true
    },
    {
        icon: 'fa fa-map-location-dot',
        category: 'İlçeler',
        title: 'İlçe temsilcilikleri',
        text: 'Patnos, Doğubayazıt, Diyadin, Eleşkirt, Tutak, Taşlıçay, Hamur ve Ağrı Merkez hemşehrileri için ilçe sayfalarımız hazırlandı.',
        action: 'İlçeleri Gör',
        route: '/hakkimizda'
    },
    {
        icon: 'fa fa-store',
        category: 'Esnaf ağı',
        title: 'Ankara’daki Ağrılı esnaflar',
        text: 'Hemşehrilerimize ait firma ve hizmetleri görünür kılarak güvenilir alışveriş ve dayanışma ağı oluşturuyoruz.',
        action: 'Firmaları Gör',
        route: '/firmalar'
    },
    {
        icon: 'fab fa-whatsapp',
        category: 'Duyurular',
        title: 'WhatsApp grubu',
        text: 'Etkinlik, toplantı, destek ve acil duyuruları kaçırmamak için dernek WhatsApp grubuna hazır mesajla katılabilirsiniz.',
        action: 'Gruba Katıl',
        href: whatsappJoinUrl,
        external: true,
        primary: true
    }
]
</script>

<style scoped>
.identity-section,
.principles-section {
    background: linear-gradient(180deg, #FFFFFF 0%, #F7FAFC 100%);
}

.identity-head,
.principles-head {
    max-width: 900px;
    margin: 0 auto 34px;
}

.identity-head h1,
.principles-head h1 {
    color: var(--dark);
    font-size: clamp(30px, 4vw, 50px);
    line-height: 1.12;
    margin: 0 0 16px;
}

.identity-head p,
.principles-head p {
    color: #5F6470;
    font-size: 18px;
    line-height: 1.7;
    margin: 0;
}

.identity-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 22px;
}

.identity-card {
    position: relative;
    overflow: hidden;
    min-height: 430px;
    border-radius: 8px;
    padding: 34px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    box-shadow: 0 18px 45px rgba(15, 23, 43, .1);
}

.identity-card::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(254, 161, 22, .16), transparent 52%);
    pointer-events: none;
}

.vision-card {
    background: var(--dark);
    color: #FFFFFF;
}

.mission-card {
    background: #FFFFFF;
    border: 1px solid rgba(15, 23, 43, .08);
    color: var(--dark);
}

.identity-card-icon {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    background: var(--primary);
    color: #FFFFFF;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    margin-bottom: 28px;
    position: relative;
    z-index: 1;
}

.identity-card span {
    color: var(--primary);
    font-weight: 800;
    letter-spacing: 0;
    text-transform: uppercase;
    position: relative;
    z-index: 1;
}

.identity-card h2 {
    color: inherit;
    font-size: clamp(26px, 3vw, 38px);
    line-height: 1.12;
    margin: 12px 0 18px;
    position: relative;
    z-index: 1;
}

.identity-card p {
    color: inherit;
    opacity: .82;
    font-size: 17px;
    line-height: 1.75;
    margin-bottom: 24px;
    position: relative;
    z-index: 1;
}

.identity-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    position: relative;
    z-index: 1;
}

.identity-tags strong {
    background: rgba(254, 161, 22, .14);
    border: 1px solid rgba(254, 161, 22, .34);
    color: inherit;
    font-size: 13px;
    padding: 8px 10px;
}

.vision-card .identity-tags strong {
    background: rgba(255, 255, 255, .08);
    border-color: rgba(255, 255, 255, .16);
}

.mission-pillars {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    margin-top: 22px;
}

.mission-pillar {
    background: #FFFFFF;
    border: 1px solid rgba(15, 23, 43, .08);
    border-radius: 8px;
    padding: 22px;
    display: grid;
    grid-template-columns: 44px minmax(0, 1fr);
    gap: 16px;
    box-shadow: 0 12px 32px rgba(15, 23, 43, .06);
    transition: .3s;
}

.mission-pillar:hover,
.principle-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 22px 48px rgba(15, 23, 43, .12);
}

.mission-pillar i {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #FFF4DF;
    color: var(--primary);
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.mission-pillar h3 {
    color: var(--dark);
    font-size: 20px;
    margin: 0 0 8px;
}

.mission-pillar p {
    color: #5F6470;
    line-height: 1.65;
    margin: 0;
}

.identity-action {
    margin-top: 22px;
    background: var(--dark);
    color: #FFFFFF;
    border-radius: 8px;
    padding: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
}

.identity-action strong,
.identity-action span {
    display: block;
}

.identity-action strong {
    font-size: 22px;
    margin-bottom: 4px;
}

.identity-action span {
    color: rgba(255, 255, 255, .74);
}

.principles-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
}

.principle-card {
    background: #FFFFFF;
    border: 1px solid rgba(15, 23, 43, .08);
    border-radius: 8px;
    padding: 26px;
    box-shadow: 0 12px 32px rgba(15, 23, 43, .06);
    transition: .3s;
}

.principle-icon {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: var(--dark);
    color: var(--primary);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    margin-bottom: 18px;
}

.principle-card h3 {
    color: var(--dark);
    font-size: 21px;
    margin-bottom: 12px;
}

.principle-card p {
    color: #5F6470;
    line-height: 1.7;
    margin: 0;
}

.principles-signature {
    margin-top: 22px;
    background: #FFFFFF;
    border: 1px solid rgba(15, 23, 43, .08);
    border-left: 4px solid var(--primary);
    border-radius: 8px;
    padding: 22px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr)) auto;
    gap: 18px;
    align-items: center;
    box-shadow: 0 12px 32px rgba(15, 23, 43, .06);
}

.principles-signature span,
.principles-signature strong {
    display: block;
}

.principles-signature span {
    color: #697386;
    font-weight: 700;
    margin-bottom: 5px;
}

.principles-signature strong {
    color: var(--dark);
    font-size: 22px;
}

.useful-section {
    background: #FFFFFF;
}

.useful-head {
    max-width: 860px;
    margin: 0 auto 30px;
}

.useful-head h1 {
    color: var(--dark);
    font-size: clamp(30px, 4vw, 48px);
    line-height: 1.12;
    margin: 0 0 14px;
}

.useful-head p {
    color: #5F6470;
    font-size: 18px;
    line-height: 1.7;
    margin: 0;
}

.useful-feature {
    background: var(--dark);
    color: #FFFFFF;
    border-radius: 8px;
    padding: 28px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 24px;
    align-items: center;
    margin-bottom: 18px;
    box-shadow: 0 18px 45px rgba(15, 23, 43, .12);
}

.useful-feature span {
    color: var(--primary);
    font-weight: 800;
    text-transform: uppercase;
}

.useful-feature h2 {
    color: #FFFFFF;
    font-size: clamp(25px, 3vw, 36px);
    line-height: 1.15;
    margin: 8px 0 12px;
}

.useful-feature p {
    color: rgba(255, 255, 255, .78);
    line-height: 1.7;
    margin: 0;
}

.useful-feature p a {
    color: var(--primary);
    font-weight: 800;
}

.useful-feature-actions {
    display: grid;
    gap: 10px;
    min-width: 220px;
}

.useful-feature-actions .btn {
    border-radius: 4px;
    padding: 12px 16px;
}

.useful-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 14px;
}

.useful-card {
    background: #FFFFFF;
    border: 1px solid rgba(15, 23, 43, .08);
    border-radius: 8px;
    box-shadow: 0 12px 32px rgba(15, 23, 43, .06);
    padding: 20px;
    display: flex;
    flex-direction: column;
    min-height: 300px;
    transition: .3s;
}

.useful-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 22px 48px rgba(15, 23, 43, .12);
}

.useful-card-icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #FFF4DF;
    color: var(--primary);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    margin-bottom: 16px;
}

.useful-card-body {
    display: flex;
    flex: 1;
    flex-direction: column;
}

.useful-card-body span {
    color: #7A4C00;
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
    margin-bottom: 8px;
}

.useful-card h3 {
    color: var(--dark);
    font-size: 20px;
    line-height: 1.25;
    margin-bottom: 10px;
}

.useful-card p {
    color: #5F6470;
    line-height: 1.62;
    margin-bottom: 18px;
}

.useful-card-actions {
    margin-top: auto;
}

.useful-card-actions .btn {
    width: 100%;
    border-radius: 4px;
    padding: 10px 12px;
    white-space: normal;
}

.useful-note {
    margin-top: 18px;
    background: #F8FAFC;
    border: 1px solid rgba(15, 23, 43, .08);
    border-radius: 8px;
    padding: 18px;
    display: grid;
    grid-template-columns: 36px minmax(0, 1fr);
    gap: 12px;
    align-items: start;
}

.useful-note i {
    color: var(--primary);
    font-size: 24px;
    margin-top: 2px;
}

.useful-note p {
    color: #5F6470;
    line-height: 1.65;
    margin: 0;
}

@media (max-width: 991.98px) {
    .identity-grid,
    .mission-pillars,
    .principles-grid,
    .useful-grid {
        grid-template-columns: 1fr;
    }

    .identity-card {
        min-height: auto;
    }

    .principles-signature {
        grid-template-columns: 1fr;
    }

    .useful-feature {
        grid-template-columns: 1fr;
    }

    .useful-feature-actions {
        min-width: 0;
    }
}

@media (max-width: 575.98px) {
    .identity-section,
    .principles-section,
    .useful-section .container-xxl {
        padding-top: 2.25rem !important;
        padding-bottom: 2.25rem !important;
    }

    .identity-head,
    .principles-head,
    .useful-head {
        text-align: left !important;
        margin-bottom: 22px;
    }

    .identity-head .section-title,
    .principles-head .section-title,
    .useful-head .section-title {
        display: block;
        text-align: left !important;
    }

    .identity-head h1,
    .principles-head h1,
    .useful-head h1 {
        font-size: 27px;
        line-height: 1.16;
        margin-bottom: 12px;
    }

    .identity-head p,
    .principles-head p,
    .useful-head p {
        font-size: 16px;
        line-height: 1.62;
    }

    .identity-card,
    .principle-card {
        padding: 18px;
    }

    .identity-card-icon {
        width: 54px;
        height: 54px;
        font-size: 23px;
        margin-bottom: 18px;
    }

    .identity-card h2 {
        font-size: 24px;
        line-height: 1.16;
        margin-bottom: 12px;
    }

    .identity-card p {
        font-size: 15px;
        line-height: 1.62;
        margin-bottom: 16px;
    }

    .identity-tags {
        gap: 7px;
    }

    .identity-tags strong {
        font-size: 12px;
        padding: 7px 9px;
    }

    .identity-action {
        align-items: stretch;
        flex-direction: column;
        padding: 18px;
    }

    .identity-action strong {
        font-size: 19px;
        line-height: 1.25;
    }

    .identity-action span {
        font-size: 14px;
        line-height: 1.55;
    }

    .identity-action .btn {
        width: 100%;
    }

    .mission-pillars,
    .principles-grid {
        gap: 12px;
    }

    .mission-pillar {
        grid-template-columns: 1fr;
        gap: 12px;
        padding: 18px;
    }

    .mission-pillar h3,
    .principle-card h3 {
        font-size: 19px;
        margin-bottom: 8px;
    }

    .mission-pillar p,
    .principle-card p {
        font-size: 15px;
        line-height: 1.58;
    }

    .principle-icon {
        width: 44px;
        height: 44px;
        font-size: 19px;
        margin-bottom: 14px;
    }

    .principles-signature {
        gap: 14px;
        padding: 18px;
    }

    .principles-signature strong {
        font-size: 19px;
    }

    .useful-feature {
        padding: 18px;
        gap: 16px;
    }

    .useful-feature h2 {
        font-size: 23px;
    }

    .useful-feature p {
        font-size: 15px;
        line-height: 1.6;
    }

    .useful-feature-actions {
        grid-template-columns: 1fr;
    }

    .useful-grid {
        gap: 12px;
    }

    .useful-card {
        min-height: 0;
        padding: 18px;
    }

    .useful-card-icon {
        width: 44px;
        height: 44px;
        font-size: 18px;
        margin-bottom: 14px;
    }

    .useful-card h3 {
        font-size: 19px;
        margin-bottom: 8px;
    }

    .useful-card p {
        font-size: 15px;
        line-height: 1.58;
        margin-bottom: 14px;
    }

    .useful-note {
        grid-template-columns: 1fr;
        padding: 16px;
    }
}
</style>
